import { render, staticRenderFns } from "./JournalNotification.vue?vue&type=template&id=3b135200&scoped=true&"
import script from "./JournalNotification.vue?vue&type=script&lang=js&"
export * from "./JournalNotification.vue?vue&type=script&lang=js&"
import style0 from "./JournalNotification.vue?vue&type=style&index=0&id=3b135200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b135200",
  null
  
)

export default component.exports